type VoiceTranscriptionSpecialtyEligibilityParams = {
	specialtyCode?: number | string | null;
	specialtyName?: string | null;
};

const TERMS_URL = 'https://www2.hapvida.com.br/portal-da-privacidade/aviso-privacidade-paciente';

const NON_ELIGIBLE_VOICE_TRANSCRIPTION_SPECIALTIES = [
	{code: 168, name: 'ACOLHIMENTO ENFERMAGEM VIVER BEM'},
	{code: 468, name: 'ASSISTENTE SOCIAL TRANSPLANTE RENAL'},
	{code: 147, name: 'ATENDIMENTO TEA'},
	{code: 169, name: 'ENFERMAGEM DE SAUDE DA FAMILIA'},
	{code: 238, name: 'ENFERMAGEM GESTAR BEM'},
	{code: 240, name: 'ENFERMAGEM TRANSPLANTE DE MEDULA OSSEA'},
	{code: 241, name: 'ENFERMAGEM TRANSPLANTE HEPATICO'},
	{code: 235, name: 'ENFERMAGEM TRANSPLANTE RENAL'},
	{code: 86, name: 'ENFERMAGEM VIVER BEM'},
	{code: 25, name: 'FISIOTERAPIA'},
	{code: 203, name: 'FISIOTERAPIA TEA'},
	{code: 146, name: 'FONOTERAPIA'},
	{code: 130, name: 'NUTRICAO'},
	{code: 136, name: 'NUTRICAO QUALIVIDA'},
	{code: 606, name: 'PSICOLOGIA QUALIVIDA'},
	{code: 145, name: 'PSICOTERAPIA'},
	{code: 987, name: 'PSICOTERAPIA LINHAS DE CUIDADO'},
	{code: 759, name: 'TELE CASE ENFERMAGEM'},
	{code: 750, name: 'TELE CASE FISIOTERAPIA'},
	{code: 751, name: 'TELE CASE FONOAUDIOLOGIA'},
	{code: 978, name: 'TELE CASE NUTRICAO'},
	{code: 979, name: 'TELE CASE PSICOLOGIA'},
	{code: 952, name: 'TELE CASE SERVICO SOCIAL'},
	{code: 216, name: 'TELE PGC TERAPIA OCUPACIONAL'},
	{code: 163, name: 'TERAPIA OCUPACIONAL-SESSAO'},
	{code: 236, name: 'TRIAGEM DE FONOAUDIOLOGIA'},
	{code: 265, name: 'TRIAGEM INFANTIL NEUROPSICOLOGIA'},
	{code: 267, name: 'TRIAGEM TERAPIA OCUPACIONAL'},
] as const;

const NON_ELIGIBLE_VOICE_TRANSCRIPTION_SPECIALTY_CODES = new Set<number>(
	NON_ELIGIBLE_VOICE_TRANSCRIPTION_SPECIALTIES.map(specialty => specialty.code),
);

const normalizeSpecialtyName = (name: string) =>
	name
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.replace(/\s+/g, ' ')
		.trim()
		.toUpperCase();

const NON_ELIGIBLE_VOICE_TRANSCRIPTION_SPECIALTY_NAMES = new Set(
	NON_ELIGIBLE_VOICE_TRANSCRIPTION_SPECIALTIES.map(specialty =>
		normalizeSpecialtyName(specialty.name),
	),
);

const normalizeSpecialtyCode = (specialtyCode?: number | string | null) => {
	if (specialtyCode === null || specialtyCode === undefined || specialtyCode === '') return null;

	const code = Number(String(specialtyCode).trim());

	return Number.isFinite(code) ? code : null;
};

const isVoiceTranscriptionTermsEligibleSpecialty = ({
	specialtyCode,
	specialtyName,
}: VoiceTranscriptionSpecialtyEligibilityParams = {}) => {
	const normalizedCode = normalizeSpecialtyCode(specialtyCode);

	if (normalizedCode !== null) {
		return !NON_ELIGIBLE_VOICE_TRANSCRIPTION_SPECIALTY_CODES.has(normalizedCode);
	}

	if (specialtyName) {
		return !NON_ELIGIBLE_VOICE_TRANSCRIPTION_SPECIALTY_NAMES.has(
			normalizeSpecialtyName(specialtyName),
		);
	}

	return true;
};

export {
	TERMS_URL,
	NON_ELIGIBLE_VOICE_TRANSCRIPTION_SPECIALTIES,
	isVoiceTranscriptionTermsEligibleSpecialty,
};
